import styles from './Gallery.module.css'
import { Col, Row } from "react-bootstrap"
import { default as GalleryComponent, GalleryImageType } from '../../../components/gallery/Gallery'

export default function Gallery() {
    const path = "./assets/images/gallery/"
    const images: GalleryImageType[] = [
        { src: "img1_rotated.png", className: styles.resizedImage },
        { src: "img2.png", className: `${styles.img2} ${styles.resizedImage}` },
        { src: "img3.png", className: `${styles.img3} ${styles.resizedImage}` },
        { src: "img4.png", className: styles.resizedImage },
        { src: "img5.png", className: styles.resizedImage },
        { src: "img6.png", className: styles.resizedImage }
    ].map(x => ({ ...x, src: `${path}${x.src}`}))

    return (
        <section>
            <Row className="m-auto mt-5 p-0 align-items-center justify-content-center">
                <Col sm="10" md="10" lg="9">
                    <GalleryComponent images={ images } />
                </Col>
            </Row>
        </section>
    )
}